import 'css-chunksrc/client/pages/zonePage/wbsPage/filters/dataTypeFilter/styles.scss';export default {
  "dataTypeFilter": "_dataTypeFilter_1bdda_1",
  "input": "_input_1bdda_7",
  "toggleArrow": "_toggleArrow_1bdda_23",
  "selectedDataTypes": "_selectedDataTypes_1bdda_31",
  "placeholder": "_placeholder_1bdda_40",
  "list": "_list_1bdda_45",
  "item": "_item_1bdda_57",
  "typeName": "_typeName_1bdda_70",
  "opened": "_opened_1bdda_77"
};